<template lang="pug">
.cp-number-list
  .title 数据智能驱动让经营效果指数级增长
  .list-wrap
    .item(v-for="(v, index) in list", :key="index")
      p {{ v.label }}
      .num-wrap
        .nums.fix
          .num.fl(ref="num1" v-show="index !== 1 && index !== 2 && index !== 3")
          .num.fl(ref="num2")
          .num.fl(ref="num3")
        span %
        .icon-wrap
          img(:src="v.arrow")
      p {{ v.str }}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { label: '用户精准度', number: 600, str: '提升6倍以上', arrow: require('../../../assets/arrowUp.png') },
        { label: '用户成交周期', number: 50, str: '缩短一半时间', arrow: require('../../../assets/arrowDown.png') },
        { label: '综合管理成本', number: 66, str: '降低66%以上', arrow: require('../../../assets/arrowDown.png') },
        { label: '流失用户召回', number: 20, str: '召回20%以上', arrow: require('../../../assets/arrowUp.png') },
        { label: '经营业绩', number: 320, str: '提升320%以上', arrow: require('../../../assets/arrowUp.png') },
      ],
      timer1: null,
      timer2: null,
      timer3: null,
      isStart: false
    }
  },
  computed: {},
  methods: {
    start () {
      if (this.isStart) return
      this.isStart = true
      let [count1, count2, count3] = [0, 0, 0]
      this.timer1 = setInterval(() => {
        count1++
        if (count1 < 54) {
          this.scrollNum('num1', 4, count1 % 10)
        }
        // if (count1 < 56) {
        //   this.scrollNum('num1', 3, count1 % 10)
        // }
        if (count1 < 57) {
          this.scrollNum('num1', 0, count1 % 10)
        } else {
          clearInterval(this.timer1)
        }
      }, 50)
      this.timer2 = setInterval(() => {
        count2++
        if (count2 < 51) {
          this.scrollNum('num2', 0, count2 % 10)
        }
        if (count2 < 53) {
          this.scrollNum('num2', 4, count2 % 10)
          this.scrollNum('num2', 3, count2 % 10)
        }
        if (count2 < 56) {
          this.scrollNum('num2', 1, count2 % 10)
        }
        if (count2 < 57) {
          this.scrollNum('num2', 2, count2 % 10)
        } else {
          clearInterval(this.timer2)
        }
      }, 40)
      this.timer3 = setInterval(() => {
        count3++
        if (count3 < 41) {
          this.scrollNum('num3', 0, count3 % 10)
          this.scrollNum('num3', 1, count3 % 10)
          this.scrollNum('num3', 3, count3 % 10)
          this.scrollNum('num3', 4, count3 % 10)
        }
        if (count3 < 47) {
          this.scrollNum('num3', 2, count3 % 10)
        } else {
          clearInterval(this.timer3)
        }
      }, 30)
    },
    scrollNum (numRef, numIndex, count) {
      const num1 = this.$refs[numRef][numIndex]
      const offsetY = -48 * count
      num1.style.backgroundPosition = `50% ${offsetY}px`
    },
    reset () {
      clearInterval(this.timer1)
      clearInterval(this.timer2)
      clearInterval(this.timer3)
      this.isStart = false
    }
  },
}
</script>
<style lang="stylus">
.cp-number-list
  .list-wrap
    margin-top 112px
    color #FFF
    display flex
    justify-content space-between
    .item
      .num-wrap
        position relative
        margin-top 35px
        margin-bottom 15px
        .nums
          display inline-block
          margin-right 17px
          .num
            width 25px
            height 47px
            background-image url('../../../assets/nums.png')
            background-position 50% 0px
            background-size 39px 478px
            background-repeat no-repeat
        span
          font-size 14px
          font-weight 400
        .icon-wrap
          width 15px
          height 27px
          position absolute
          top -10px
          right -3px
          overflow hidden
          img
            width 15px
      p
        &:first-child
          font-size 20px
        &:last-child
          font-size 14px
          font-weight 300
          color #C5C8CE
      &:nth-of-type(1)
        .num-wrap
          .icon-wrap
            img
              animation arrowSlideUp 1.3s linear infinite
      &:nth-of-type(2)
        .num-wrap
          .icon-wrap
            right 36px
            img
              animation arrowSlideDown 1.3s linear infinite
      &:nth-of-type(3)
        .num-wrap
          .icon-wrap
            right 36px
            img
              animation arrowSlideDown 1.3s linear infinite
      &:nth-of-type(4)
        .num-wrap
          .icon-wrap
            right 10px
            img
              animation arrowSlideUp 1.3s linear infinite
      &:nth-of-type(5)
        .num-wrap
          .icon-wrap
            img
              animation arrowSlideUp 1.3s linear infinite
@keyframes arrowSlideUp {
  0% {
    transform translate3d(0, 20px, 0)
    opacity 0
  }
  40% {
    opacity 1
  }
  60% {
    opacity 1
  }
  100% {
    transform translate3d(0, -10px, 0)
    opacity 0
  }
}
@keyframes arrowSlideDown {
  0% {
    opacity 0
    transform translate3d(0, -10px, 0)
  }
  40% {
    opacity 1
  }
  60% {
    opacity 1
  }
  100% {
    opacity 0
    transform translate3d(0, 20px, 0)
  }
}
</style>
